module.exports = __webpack_public_path__ + "static/food-bank-body-1-416b6d9f5fe83a89247b0e41a74d18bb.png";